import { useState } from "react";
import SectionHeader from "./SectionHeader";
import { weeklySchedule } from "@/mocks/manhwa";

export default function WeeklySchedule() {
  const today = new Date().getDay();
  const defaultDay = today === 0 ? 6 : today - 1;
  const [selected, setSelected] = useState(defaultDay);
  const shown = weeklySchedule[selected];

  return (
    <section id="schedule" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        tag="连载进度"
        title="每周更新周表"
        desc="韩漫连载更新提醒排期一目了然，切换任意一天即可查看当日的更新计划与最新话进度。"
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex gap-2 overflow-x-auto pb-1 lg:flex-col lg:gap-3 lg:pb-0">
          {weeklySchedule.map((day, idx) => (
            <button
              key={day.day}
              type="button"
              onClick={() => setSelected(idx)}
              className={`flex min-w-[84px] flex-col items-center justify-center gap-0.5 whitespace-nowrap rounded-xl border px-4 py-3 transition-colors ${
                selected === idx
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              <span className="text-sm font-semibold">{day.day}</span>
              <span className={`text-[11px] ${selected === idx ? "text-background-100" : "text-foreground-400"}`}>
                {day.date}
              </span>
            </button>
          ))}
        </div>

        <div className="flex-1 rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-6">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              {shown.day}更新 · 共 {shown.items.length} 部
            </h3>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-timer-flash-line text-sm"></i>
              已同步最新话
            </span>
          </div>
          <ul className="mt-5 divide-y divide-background-200/70">
            {shown.items.map((it) => (
              <li key={it.title} className="flex flex-col gap-2 py-4 first:pt-0 last:pb-0 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 md:text-base">{it.title}</h4>
                    <span className="mt-0.5 inline-block rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
                      {it.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-3 pl-12 sm:pl-0">
                  <span className="text-sm font-medium text-primary-600">{it.chapter}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line text-sm"></i>
                    {it.time}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}